import { render } from "./FooterNav.vue?vue&type=template&id=7049a2e1&scoped=true"
import script from "./FooterNav.vue?vue&type=script&lang=js"
export * from "./FooterNav.vue?vue&type=script&lang=js"

import "./FooterNav.vue?vue&type=style&index=0&id=7049a2e1&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/vue-antd-tool-web 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7049a2e1"]])

export default __exports__